import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialog} from '@angular/material';
import { HttpClient } from '@angular/common/http';
import {UserService} from '../../services/user.service';
import SignaturePad from "signature_pad";
import {Transport} from '../../model/Entities/Transport';
import {User} from '../../model/Entities/User';
import {CompleteTransportCancelConfirmDialogComponent} from '../CompleteTransportCancelConfirmDialogComponent/complete-transport-cancel-confirm.dialog.component';


@Component({
    selector: 'complete-transport-dialog',
    templateUrl: './completeTransport.dialog.component.html',
})

export class CompleteTransportDialogComponent {
    transport: Transport;
    new: boolean = true;


    constructor(public dialog: MatDialogRef<CompleteTransportDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any,
                private http: HttpClient,
                private matDialog: MatDialog) {

        this.transport = data.transport;
        if (this.transport.completeSign) {
            this.new = false;
        }
    }

    ngAfterViewInit(): void {
        this.transport.completeSign = new SignaturePad(document.getElementById("signature") as HTMLCanvasElement);
        console.log(document.getElementById("signature") as HTMLCanvasElement);

    }

    clearSignature() {
        this.transport.completeSign.clear();
    }

    save () {
        this.transport.completeSign = this.transport.completeSign.toDataURL();
    }

    checkValidity() {
        if (this.transport.completeDatetime == null) {
            return false;
        }
        // if (
        //     this.transport.completeDatetime == null ||
        //     this.transport.completeAmount === null ||
        //     this.transport.completePerson == null ||
        //     this.transport.completeSign == null
        // ) {
        //     return false;
        // }
        //
        // /* data:image/png ... se jedná o prázný obrázek = bez podpisu */
        // if (this.transport.completeSign.toDataURL() === 'data:image/png;base64,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') {
        //     return false;
        // }
        return true;
    }

    cancelCompletion() {
        const confirmDialog = this.matDialog.open(CompleteTransportCancelConfirmDialogComponent, {
            width: '400px',
            data: { transport: this.transport }
        });

        confirmDialog.afterClosed().subscribe(result => {
            if (result === true) {
                this.transport.completeDatetime = null;
                this.transport.completePerson = null;
                this.transport.completeAmount = null;
                this.transport.completeSign = null;
                this.transport.completeUserId = null;
                this.dialog.close(this.transport);
            }
        });
    }
}



// WEBPACK FOOTER //
// /app/src/TransportModule/CompleteTransportDialogComponent/completeTransport.dialog.component.ts